module.exports = __webpack_public_path__ + "static/ReCaptcha v2 for Contact Form 7-39516c2c85a2f11067bb5af353d62970.svg";